export var ACTION;
(function (ACTION) {
    ACTION["REPAYMENT"] = "REPAYMENT";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["OPEN_TAB"] = "OPEN_TAB";
    ACTION["GO_TO_AUTOPAY"] = "GO_TO_AUTOPAY";
    ACTION["POLL_AGREEMENT_STATUS"] = "POLL_AGREEMENT_STATUS";
    ACTION["GO_TO_LOAN_AGREEMENT"] = "GO_TO_LOAN_AGREEMENT";
})(ACTION || (ACTION = {}));
